module.exports = "/_next/static/images/1273db534b0bfd92934b64720dd9a666-logos-compliance.png.webp";